import * as React from 'react';

import { useSidePanel } from 'src/registry/providers/SidePanelProvider';

export function useSingleRowSelection() {
    const [rowSelectionState, setRowSelectionState] = React.useState<Record<string, boolean>>({});
    const { openPanel, closePanel } = useSidePanel();

    const clearSelection = React.useCallback(() => {
        setRowSelectionState({});
    }, [closePanel]);

    const selectRow = React.useCallback(
        (rowId: string) => {
            setRowSelectionState({ [rowId]: true });
        },
        [openPanel],
    );

    return { rowSelectionState, setRowSelectionState, selectRow, clearSelection };
}
